// extracted by mini-css-extract-plugin
export default {"wrap":"Carousel_wrap__HFplw","row":"Carousel_row__lqLXJ","bannerInfo":"Carousel_bannerInfo__D0amI"};